module.exports = __webpack_public_path__ + "img/flow_customer-service_hover.53dd4baf.svg";